// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2rWwI","label":"Labeled_label__2jymH","divider":"Labeled_divider__1GNhC"};